import type { TransitionEventHandler } from 'react';
import { Loader } from '@/components/ui/loader';

/**
 * The handoff veil's surface (#5559): the app theme with the standard spinner
 * at FullScreenLoader's position (its message line reserved, no copy). Shared
 * by the root veil and the signed-in /login cover, so they can't drift.
 */
export function AuthHandoffSurface({
  state = 'covering',
  entrance = 'none',
  label,
  onTransitionEnd,
}: {
  state?: 'covering' | 'revealing';
  entrance?: 'none' | 'fade';
  label: string;
  onTransitionEnd?: TransitionEventHandler<HTMLDivElement>;
}) {
  return (
    <div
      data-auth-handoff-veil
      data-app-surface
      data-state={state}
      data-entrance={entrance}
      className="bg-background text-foreground flex items-center justify-center px-6"
      onTransitionEnd={onTransitionEnd}
    >
      <div
        data-auth-handoff-mark
        className="flex flex-col items-center gap-3 text-base font-medium"
      >
        <Loader intent="primary" size="md" aria-label={label} />
        <span aria-hidden className="block h-6" />
      </div>
    </div>
  );
}
